import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['checkbox']

  connect() {
    // Set the initial indeterminate state of parent checkboxes
    this.checkboxTargets.forEach(checkbox => {
      const childCheckboxes = this.checkboxTargets.filter(cb => cb.dataset.parentId === checkbox.dataset.instanceId)
      const anyChildChecked = childCheckboxes.some(cb => cb.checked)
      const allChildrenChecked = childCheckboxes.every(cb => cb.checked)

      if (childCheckboxes.length > 0) {
        checkbox.indeterminate = anyChildChecked && !allChildrenChecked
      }
    })
  }

  toggleChildren(event) {
    const instanceId = event.target.dataset.instanceId
    const isChecked = event.target.checked

    // Start with a queue containing the initial area ID
    const queue = [instanceId]

    while (queue.length > 0) {
      const currentParentId = queue.shift()

      // Find all checkboxes whose data-parent-id matches the current parent ID
      this.checkboxTargets.forEach(checkbox => {
        if (checkbox.dataset.parentId === currentParentId) {
          checkbox.checked = isChecked

          // Add this checkbox's instanceId to the queue to process its children
          queue.push(checkbox.dataset.instanceId)
        }
      });
    }

    // Set the indeterminate state of parent checkboxes
    this.setInderminateState(event.target)
  }

  setInderminateState(checkbox) {
    let parentId = checkbox.dataset.parentId

    while (parentId) {
      const parentCheckbox = this.checkboxTargets.find(cb => cb.dataset.instanceId === parentId)

      if (parentCheckbox) {
        const childCheckboxes = this.checkboxTargets.filter(cb => cb.dataset.parentId === parentId)
        const allChecked = childCheckboxes.every(cb => cb.checked)
        const allUnchecked = childCheckboxes.every(cb => !cb.checked)

        // Set indeterminate if some children are checked but not all
        parentCheckbox.indeterminate = !allChecked && !allUnchecked
        parentCheckbox.checked = allChecked

        // Move up the tree
        parentId = parentCheckbox.dataset.parentId
      } else {
        break
      }
    }
  }
}
